function humanize(obj) {
  return obj.human_readable_name || obj.name;
}

export default humanize;
